import React, { useEffect } from 'react';

import {
  useGroupUserInvitationsState,
  useGroupUserInvitationsActions
} from './GroupUserInvitationsContext';

import {
  getGroupUserInvitations,
} from './restApi';

const GroupUserInvitationsLoader = () => {
  const groupUserInvitationsState = useGroupUserInvitationsState();
  const { onResponse, onError } = useGroupUserInvitationsActions();

  useEffect(() => {
    const groupId = groupUserInvitationsState?.groupId;
    if (groupId) {
      getGroupUserInvitations({
        groupId,
        onResponse,
        onError,
      });
    }
  }, [groupUserInvitationsState?.groupId]);

  return null;
};

export default GroupUserInvitationsLoader;
